import { AxiosError } from 'axios';
import { useState, useEffect } from 'react';
import { DashboardService } from 'community/dashboard/services/dashboardService';
import authService from 'common/services/authService';

const dashboardService = new DashboardService();

const useUser = () => {
  const [user, setUser] = useState<null | any>(null);

  const [
    responseError,
    setResponseError,
  ] = useState<AxiosError | null>(null);

  useEffect(() => {
    if (authService.isAuthenticated) {
      dashboardService
        .getUser()
        .then((response) => setUser(response.data[0]))
        .catch((error) => setResponseError(error));
    }
  }, []);

  return { user, responseError };
};

export default useUser;
